export default class Meta {
    static get(name: string = ''): string {
        return document.querySelector(`meta[name="${name}"]`)
            .getAttribute('content');
    }
}
